/**
 * zxw
 * @description 阶段成绩计算规则列表
 * @Date 2023/1/31
 */
 import React from 'react'
 import { component_tool, framework_tool } from '../../../../tool';
 import { WizTableForm } from '../../../common'
 const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
 const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
 import HighSet from "@/containers/common/highSet";
 
 let { WizModal } = component_tool;
 
 //配置项
 let componentName = 'trainPathStageScoreRule'
 const columns = [
   {
     name: "id",
     fromItem: {
       type: "hidden"
     }
   },
   {
    title: "路径名称",
    name: "pathName",
    tableItem: {
      // width: 300
    },
   },
   {
     title: "阶段名称",
     name: "entityName",
     searchItem: {},
     tableItem: {
       // width: 300
     },
   },
   {
     title: "状态",
     name: "state",
     dataIndex: "state",
     dict: [
       { code: 1, codeName: '无效' },
       { code: 2, codeName: '有效' },
       { code: 3, codeName: '待更新' }
     ],
     searchItem: {
       type: 'select'
     },
     tableItem: {
     },
   },
   {
    title: "创建时间",
    name: "createTime",
    dataIndex: "createTime",
    tableItem: {}
    }
 ];
 
 const templateConfig = {
   mainProps: {},
   content: {
     name: "WizTableList",
     params: {
       columns,
       searchBarProps: {
         buttonSort:['add'],
         buttons: [
           {
             key: 'add',
             custom: true,
             params: { icon: 'plus', children: '新增', type: 'primary' },
             customOnClick: {
               key: 'jumpPage',
               params: {
                 key: 'push',
                 pathname: '/trainPathStageScoreRule/trainPathStageScoreRuleAdd'
               }
             }
           },
           {
             key: 'delete',
             custom: true,
             params: { icon: 'delete', children: '删除', type: 'danger',},
             customOnClick: {
               key: "action",
               params: {
                 apiKey: "del",
                 apiParams: {}
               },
               formatParams: (rows, record, filters, callback) => {
                 if (rows.length < 1){
                   wizNotice.warn("请选择一条规则！");
                   return null
                 }
                 let ids = [];
                 for (let i = 0;i< rows.length;i++){
                   ids.push(rows[i].id)
                 }
                 const content = `删除后数据不可恢复，您确定要删除选中的规则吗？`;
                 WizModal.confirm({
                   title: '注意', content,
                   onOk: () => {
                     callback && callback({
                       ids: ids
                     })
                   },
                   onCancel() {
                   }
                 });
                 return null
               }
             }
           },
         ]
       },
       modalFormProps: {},
       dataTableProps: {
         rowKey: "id",
         selectType: "checkbox",
         isScroll: true,
         bordered: false,
         paging: false,
         loading: false
       },
         rowOperateSort:['update','enableOrDisable'],
       rowOperateView: [
         {
           key: "update",
           custom: true,
           params: { children: "编辑" },
           customOnClick: {
             key: "jumpPage",
             params: {
               key: "push",
               pathname: "/trainPathStageScoreRule/trainPathStageScoreRuleUpd"
             }
           }
         },
         {
            key: "enableOrDisable",
            custom: true,
            params: {},//状态  1无效  2有效
            textFormat: {
              recordKey: 'state',
              dirt: {  2: '禁用', 1: '启用' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 1 ? "启用" : "禁用"//根据状态判断提示语
                  }该规则？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 2 ? 1 : 2,//判断传值
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
       ],
     }
   }
 };
 
 const apis = {
   list: {
     path: `${componentName}/pageList`,
     payload: {
       key: `${componentName}@list`,
       apiParams: {}
     }
   },
   del:{
     path: `${componentName}/del`,
     payload: {
       key: `${componentName}@del`,
       apiParams: {}
     }
   },
   add: {
     path: `${componentName}/add`,
     payload: {
       key: `${componentName}@add`,
       apiParams: {}
     }
   },
   upd: {
     path: `${componentName}/upd`,
     payload: {
       key: `${componentName}@upd`,
       apiParams: {}
     }
   },
   enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  }
 }
 
 let reduxTemplateCofig = (args) => {
   return {
     apis,
     componentName,
     initApiKeys: ['list'],
     needLoading: true,
     ...args
   }
 };
 
 export { reduxTemplateCofig, templateConfig };
 